import React, { type PropsWithChildren } from "react";
import styles from "features/Library/Common/QuestionsForm/Questions/QuestionHeader/QuestionHeader.module.scss";
import { RemoveButton } from "features/Library/Common/QuestionsForm/RemoveButton/RemoveButton";

type Props = PropsWithChildren<{ title: string; canRemove: boolean; onRemove: () => void }>;

export const QuestionHeader = ({ children, title, canRemove, onRemove }: Props) => {
  return (
    <div className={styles.container}>
      <span className={styles.title}>{title}</span>

      <div className={styles.controllers}>
        <div className={styles.additional}>{children}</div>

        {canRemove && <RemoveButton onClick={onRemove} />}
      </div>
    </div>
  );
};
